import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions';

export const RequestsEditService = {
  async updateRequest(userId: string, id: string, data: any) {
    await permissionEngine.assert(userId, 'inventory.requests.update', { 
      companyId: data.companyId,
      projectId: data.projectId 
    });
    
    const { error: reqError } = await supabase
      .from('requests')
      .update({
        title: data.title,
        description: data.description,
        project_id: data.projectId,
        zone_id: data.zoneId,
        needed_date: data.neededDate,
        priority: data.priority,
        updated_at: new Date().toISOString(),
      })
      .eq('id', id);

    if (reqError) throw reqError;

    // Delete old items and insert new ones for simplicity
    await supabase.from('material_request_items').delete().eq('request_id', id);

    if (data.items && data.items.length > 0) {
      const { error: itemsError } = await supabase
        .from('material_request_items')
        .insert(
          data.items.map((item: any) => ({
            request_id: id,
            inventory_item_id: item.inventoryItemId,
            requested_quantity: item.requestedQuantity,
            unit: item.unit,
            note: item.note,
          }))
        );

      if (itemsError) throw itemsError;
    }
  }
};
